var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.003 2C12.4172 2 12.753 2.33579 12.753 2.75V10.7015L19.6397 6.72548C19.9984 6.51837 20.4571 6.64128 20.6642 7C20.8714 7.35872 20.7484 7.81741 20.3897 8.02452L13.5035 12.0003L20.3888 15.9755C20.7475 16.1826 20.8705 16.6413 20.6633 17C20.4562 17.3587 19.9975 17.4816 19.6388 17.2745L12.753 13.299V21.25C12.753 21.6642 12.4172 22 12.003 22C11.5888 22 11.253 21.6642 11.253 21.25V13.2996L4.36828 17.2745C4.00956 17.4816 3.55087 17.3587 3.34376 17C3.13666 16.6413 3.25956 16.1826 3.61828 15.9755L10.5035 12.0003L3.61731 8.02452C3.25859 7.81741 3.13569 7.35872 3.34279 7C3.5499 6.64128 4.00859 6.51837 4.36731 6.72548L11.253 10.7009V2.75C11.253 2.33579 11.5888 2 12.003 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.c4c81bb7860e89952ed0f813e9be5522.svg";
export { ForwardRef as ReactComponent };